export const APPLIANCE_TYPE = {
    HEAT_PUMP: 'HeatPump',
    AIR_CONDITIONER: 'Air Conditioner',
    SMART_PLUG: 'Smart Plug',
    TV: 'TV',
};
